import React from 'react'
import injectSheet from 'react-jss'
import style from 'components/Camera/style'
import MarkerWithLabel from 'markerWithLabel'
import getIconDetails, { cameraIconDetails } from './helpers/getIconDetails'

class CameraMarker extends React.Component {
  componentWillMount() {
    const { addToMarkers, position, heading, map, color, locked, name, id, isLens, form, showSimpleCameraIcon, fisheyeAov, drawingWire, classes } = this.props

    const { cameraIcon, lockIconDetails, outlineIcon, showLockMarker, showOutlineMarker } = getIconDetails(this.props)

    this.marker = new MarkerWithLabel({
      export: EXPORT,
      position: position,
      icon: cameraIcon,
      raiseOnDrag: false,
      labelContent: name,
      labelVisible: false,
      labelAnchor: new google.maps.Point(-10, 0),
      labelClass: classes.cameraLabel,
      labelStyle: { opacity: 0.75 },
      draggable: !locked && !drawingWire,
      visible: !isLens,
      zIndex: 0,
      map
    })

    google.maps.event.addDomListener(
      this.marker,
      'dragend',
      e => {
        this.props.updateCalculatorAction(e.latLng, 'location', id, true)
        this.props.processStreetView()
        this.props.setCameraDragging(false)
      }
    )

    google.maps.event.addDomListener(
      this.marker,
      'dragstart',
      _ => this.props.setCameraDragging(true)
    )

    this.lockIcon = new google.maps.Marker({
      position: position,
      icon: lockIconDetails,
      visible: showLockMarker,
      zIndex: -100,
      map
    })

    this.markerOutline = new google.maps.Marker({
      position: position,
      icon: outlineIcon,
      visible: showOutlineMarker,
      clickable: false,
      draggable: false,
      zIndex: 1,
      map
    })

    addToMarkers('camera', this.marker)
    addToMarkers('lockIcon', this.lockIcon)
    addToMarkers('cameraOutline', this.markerOutline)

    this.icons = [this.marker, this.lockIcon, this.markerOutline]
  }

  componentDidMount() {
    const { id, messageAction } = this.props
    this.marker.addListener('dragend', e => this.props.updateCalculatorAction(e.latLng, 'location', id, true))
    this.marker.addListener('mouseover', _ => this.marker.set('labelVisible', true))
    this.marker.addListener('mouseout', _ => this.marker.set('labelVisible', false))
    this.marker.addListener('mousedown', _ => this.props.locked && messageAction('generalError', 'This camera is locked. Right click to unlock.'))
  }

  componentWillReceiveProps(nextProps) {
    const { position, heading, color, locked, name, isLens, form, showSimpleCameraIcon, fisheyeAov, drawingWire } = nextProps

    if (this.props.position.lat() !== position.lat() ||
        this.props.position.lng() !== position.lng()) {
      this.updateIconPosition(position)
    }

    if (locked !== this.props.locked && !EXPORT && !isLens) {
      this.lockIcon.setVisible(locked)
      this.marker.setOptions({ draggable: !locked && !drawingWire })

      if (fisheyeAov === 360) {
        const { outlineIcon, showLockMarker } = getIconDetails(nextProps)
        this.markerOutline.set('icon', outlineIcon)
        this.lockIcon.setVisible(showLockMarker)
      }
    }

    if (drawingWire !== this.props.drawingWire) this.marker.setOptions({ draggable: !locked && !drawingWire })

    if (this.props.heading !== heading) this.updateIconHeading(heading, form, showSimpleCameraIcon, fisheyeAov)

    if (color !== this.props.color) this.updateIconColor(color, !showSimpleCameraIcon && fisheyeAov === 360)

    if (name !== this.props.name) this.marker.set('labelContent', name)

    if (form !== this.props.form || showSimpleCameraIcon !== this.props.showSimpleCameraIcon || fisheyeAov !== this.props.fisheyeAov) {
      this.updateIcons(nextProps)
    }
  }

  updateIconPosition(position) {
    for (const icon of this.icons) {
      icon.setPosition(position)
    }
  }

  updateIconHeading(heading, form, override, fisheyeAov) {
    const { rotateOffset } = cameraIconDetails(form, override, fisheyeAov)

    this.marker.set('icon', {
      ...this.marker.get('icon'),
      rotation: heading + rotateOffset
    })

    this.lockIcon.set('icon', {
      ...this.lockIcon.get('icon'),
      rotation: override || !form || form === 'Box' ? heading : heading - 90
    })
  }

  updateIconColor(color, isFisheyeIcon) {
    if (isFisheyeIcon) {
      this.marker.set('icon', { ...this.marker.get('icon'), fillColor: color })
      this.lockIcon.set('icon', { ...this.lockIcon.get('icon'), strokeColor: color, fillColor: color })
      return
    }

    for (const icon of this.icons) {
      const newIcon = icon.get('icon')
      newIcon.strokeColor = color
      newIcon.fillColor = color
      icon.set('icon', newIcon)
    }
  }

  updateIcons = (nextProps) => {
    const { cameraIcon, lockIconDetails, outlineIcon, showLockMarker, showOutlineMarker } = getIconDetails(nextProps)

    this.marker.set('icon', cameraIcon)
    this.lockIcon.set('icon', lockIconDetails)
    this.markerOutline.set('icon', outlineIcon)

    this.lockIcon.setVisible(showLockMarker)
    this.markerOutline.setVisible(showOutlineMarker)
  }

  shouldComponentUpdate() {
    return false
  }

  render() {
    return null
  }
}

export default injectSheet(style)(CameraMarker)



// WEBPACK FOOTER //
// ./src/components/Camera/CameraMarker.js